import firebase from 'firebase/app';

import { MirrorService } from 'services/MirrorService';

import { WebpushApi, WebpushErrorTypes } from 'api/WebpushApi';
import { getLocalStorageItem, setLocalStorageItem } from 'helpers/localStorage';

import { getWebpushApiData } from './webpush';

import 'firebase/messaging';

const config = {
  apiKey: 'AIzaSyAGnYKxsCNvoUNcS1G5eXp4_rzLMg2siIk',
  authDomain: 'hookupers-bd3df.firebaseapp.com',
  databaseURL: 'https://hookupers-bd3df.firebaseio.com',
  projectId: 'hookupers-bd3df',
  storageBucket: 'hookupers-bd3df.appspot.com',
  messagingSenderId: '641628314227',
  appId: '1:641628314227:web:5a5219a0fca82b99f82806',
};

const FB_TOKEN_LS_KEY = 'fb';

const ERRORS_LIST_TO_SKIP_RETRY_LOGIC = [
  'Registration failed - push service error',
  'The notification permission was not granted',
  'User denied permission to use the Push API',
];

// const ERRORS_LIST_TO_SKIP_ALERTS = [
//   'Internal error',
//   'Failed to fetch',
//   'Error retrieving push subscription.',
//   'Request is missing required authentication credential. Expected OAuth 2 access token, login cookie or other valid authentication credential.',
//   'A problem occurred while subscribing the user to FCM: Request contains an invalid argument.',
//   'A problem occurred while subscribing the user to FCM: The service is currently unavailable.',
//   'The database connection is closing.', // ? Failed to execute 'transaction' on 'IDBDatabase': The database connection is closing.
//   'Could not process request. Application offline.',
//   'could not retrieve the public key',
// ];

const shouldSkipLogicByError = (errorsList: string[], errorMessage?: any) => {
  if (!errorMessage) return true;

  return !!errorsList.find((errorToIgnore) =>
    errorMessage?.includes(errorToIgnore)
  );
};

const sleep = (sleepTime: number) =>
  // eslint-disable-next-line no-promise-executor-return
  new Promise((resolve) => setTimeout(resolve, sleepTime));

firebase.initializeApp(config);

const messaging = firebase.messaging?.isSupported()
  ? firebase.messaging()
  : null;

export const saveFbTokenInLocalStorage = (token: string) => {
  setLocalStorageItem(FB_TOKEN_LS_KEY, token);
};

export const getFbTokenFromLocalStorage = () =>
  getLocalStorageItem(FB_TOKEN_LS_KEY);

export const firebaseGetToken = async () => {
  // const startDate = Date.now();

  if (!messaging) {
    WebpushApi.trackError({
      message: 'Firebase-sdk is unsupported',
      webpushesApiData: getWebpushApiData(),
      operation: WebpushErrorTypes.SubscribeError,
    });

    throw new Error('Firebase-sdk is unsupported');
  }

  if (!('serviceWorker' in navigator)) {
    WebpushApi.trackError({
      message: 'ServiceWorker is unsupported',
      webpushesApiData: getWebpushApiData(),
      operation: WebpushErrorTypes.SubscribeError,
    });

    throw new Error('ServiceWorker is unsupported');
  }

  const serviceWorkerRegistration = await navigator.serviceWorker.register(
    '/firebase-messaging-sw.js',
    {
      scope: `${
        window.location?.origin || `https://${MirrorService.domain}`
      }/firebase-cloud-messaging-push-scope`,
    }
  );

  try {
    // ?
    // ?  first try to get token
    // ?
    const token = await messaging.getToken({
      serviceWorkerRegistration,
    });

    saveFbTokenInLocalStorage(token);

    return token;
  } catch (err: any) {
    // ? Enable this if you got some problems with web pushes
    // ? Also its good idea to enable this tracking every 60 days to check logic for new errors
    //  TrackingApi.trackError({
    //    type: 'warning',
    //    message: `Firebase: (attempt 1) ${err?.message}`,
    //    params: { stack: err?.stack, duration: Date.now() - startDate },
    //  });

    WebpushApi.trackError({
      message: 'Firebase: (attempt 1) token creation error',
      webpushesApiData: getWebpushApiData(),
      operation: WebpushErrorTypes.SubscribeError,
    });

    // ? this is user browser error, we can`t fix them with retry logic
    if (shouldSkipLogicByError(ERRORS_LIST_TO_SKIP_RETRY_LOGIC, err?.message)) {
      throw err;
    }

    // ?
    // ?  second try to get token after fail and 500 msec
    // ?
    await sleep(500);

    try {
      const retryToken = await messaging.getToken({
        serviceWorkerRegistration,
      });

      saveFbTokenInLocalStorage(retryToken);

      return retryToken;
    } catch (error: any) {
      // ? Enable this if you got some problems with web pushes
      //  if (!shouldSkipLogicByError(ERRORS_LIST_TO_SKIP_ALERTS, error?.message))
      //   TrackingApi.trackError({
      //    type: 'warning',
      //    message: `Firebase: (attempt 2) ${error?.message}`,
      //    params: { stack: error?.stack, duration: Date.now() - startDate },
      //  });

      WebpushApi.trackError({
        message: 'Firebase: (attempt 2) token creation error',
        webpushesApiData: getWebpushApiData(),
        operation: WebpushErrorTypes.SubscribeError,
      });

      throw error;
    }
  }
};
